import React, { useState, useEffect } from 'react';
import { FaBars, FaHome, FaList, FaSignOutAlt, FaUserPlus, FaRegFileAlt, FaUserTie, FaGamepad } from 'react-icons/fa';
import { FaWhatsapp, FaEnvelope, FaSms } from 'react-icons/fa';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import './layout.css';
import logo from '../images/WhatsApp Image 2025-06-14 at 11.22.41 AM.jpeg';
import Notification from '../components/Notification/Notification';

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [showTemplatesSubmenu, setShowTemplatesSubmenu] = useState(false);

  useEffect(() => {
    // 🔥 Function to get user
    const getUser = () => {
      const u = JSON.parse(localStorage.getItem('user') || 'null');
      setUser(u);
    };

    // Initial load
    getUser();

    // 🔥 Listen for auth changes (login/logout)
    const handleAuthChange = () => {
      getUser();
    };

    window.addEventListener('authChange', handleAuthChange);
    window.addEventListener('storage', handleAuthChange);

    return () => {
      window.removeEventListener('authChange', handleAuthChange);
      window.removeEventListener('storage', handleAuthChange);
    };
  }, []);

  const toggleSidebar = () => setCollapsed(!collapsed);
  const toggleTemplatesSubmenu = () => setShowTemplatesSubmenu(!showTemplatesSubmenu);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // 🔥 IMPORTANT: Event dispatch karein taake button hide ho
    window.dispatchEvent(new Event('authChange'));
    
    navigate('/');
  };

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <div className="app-container">
      {/* Sidebar */}
      <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <div className="toggle-btn" onClick={toggleSidebar}>
            <FaBars />
          </div>
        </div>

        <nav className="sidebar-menu">
          <NavLink
            to="/dashboard"
            className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`}
          >
            <FaHome className="menu-icon" />
            <span className="menu-text">Dashboard</span>
          </NavLink>

          <NavLink
            to="/view-list"
            className={`menu-item ${isActive('/view-list') ? 'active' : ''}`}
          >
            <FaList className="menu-icon" />
            <span className="menu-text">View List</span>
          </NavLink>

          {/* Templates Main Menu Item */}
          <div
            className={`menu-item ${isActive('/templates') ? 'active' : ''}`}
            onClick={toggleTemplatesSubmenu}
          >
            <div className="menu-icon-container">
              <FaRegFileAlt className="menu-icon" />
              {!collapsed && <span className="menu-text">Templates</span>}
            </div>
          </div>

          {/* Templates Submenu */}
          {!collapsed && showTemplatesSubmenu && (
            <div className="submenu">
              <NavLink
                to="/templates/whatsapp"
                className={`submenu-item ${isActive('/templates/whatsapp') ? 'active' : ''}`}
              >
                <FaWhatsapp className="submenu-icon" />
                <span>WhatsApp</span>
              </NavLink>

              <NavLink
                to="/templates/email"
                className={`submenu-item ${isActive('/templates/email') ? 'active' : ''}`}
              >
                <FaEnvelope className="submenu-icon" />
                <span>Email</span>
              </NavLink>

              <NavLink
                to="/templates/sms"
                className={`submenu-item ${isActive('/templates/sms') ? 'active' : ''}`}
              >
                <FaSms className="submenu-icon" />
                <span>SMS</span>
              </NavLink>
            </div>
          )}

          {user && user.role !== 'admin' && user.role !== 'vendor' && (
            <NavLink
              to="/game"
              className={`menu-item ${isActive('/game') ? 'active' : ''}`}
            >
              {/* <FaGamepad className="menu-icon" /> */}
              {/* <span className="menu-text">Game</span> */}
            </NavLink>
          )}

          {(user?.role === 'admin' || user?.role === 'vendor') && (
            <NavLink
              to="/add-user"
              className={`menu-item ${isActive('/add-user') ? 'active' : ''}`}
            >
              <FaUserPlus className="menu-icon" />
              <span className="menu-text">Add User</span>
            </NavLink>
          )}

          {(user?.role === 'admin' || user?.role === 'vendor') && (
            <NavLink
              to="/vendors"
              className={`menu-item ${isActive('/vendors') ? 'active' : ''}`}
            >
              <FaUserTie className="menu-icon" />
              <span className="menu-text">
                {user?.role === 'admin' ? 'Vendors' : 'Users'}
              </span>
            </NavLink>
          )}
        </nav>
      </div>

      {/* Main Content */}
      <div className={`main-content ${collapsed ? 'collapsed-main' : ''}`}>
        {/* Navbar */}
        <header className="navbar">
          <div className="navbar-content">
            <div className="navbar-left">
              <img src={logo} alt="Company Logo" className="navbar-logo" />
              {!collapsed && <h1 className="app-title">CRM Dashboard</h1>}
            </div>

            <div className="navbar-right">
              <Notification />

              <div className="user-profile">
                <span className="username">
                  {user?.name || 'User'}
                </span>

                <button
                  className="logout-btn"
                  onClick={handleLogout}
                  aria-label="Logout"
                >
                  <FaSignOutAlt className="logout-icon" />
                  {!collapsed && (
                    <span className="logout-text">Logout</span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="page-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;